<script setup lang="ts">
defineProps<{ error: any }>()
</script>

<template>
  <NuxtLayout>
    <VmzError404 v-if="error.statusCode === 404" />
    <VmzErrorGeneral v-else :error="error" />
  </NuxtLayout>
</template>
